import { Injectable, inject } from '@angular/core';
import { NucleusCapabilityContract } from '@nucleus/ui-base';
import { ApplicationConfigService } from '../application-config.service';

/**
 * NUC-114: the single capability gate every nucleus-* library injects via
 * CAPABILITY_CHECKER (e.g. @nucleus/mail-template-ui, audit-ui, user-ui, org-units,
 * system-property). Resolves an `entity:action` capability string against the current
 * user's authority list, and NOTHING else.
 *
 * The coarse admin / devops escape hatch was removed here for the same reason it was
 * removed from PermissionCheckerService: the server recognises no such authority. Every
 * server gate is a literal @PreAuthorize("hasAuthority('entity:action')"), so a wildcard
 * here only made the shared library screens MORE permissive than the API that backs them
 * - offering a button that 403s when pressed.
 *
 * This one matters more than the app's own checker, because it is what the nucleus
 * libraries gate themselves with: leaving it wide open would have closed the app's front
 * door and left every library screen unlocked.
 */
@Injectable({ providedIn: 'root' })
export class CapabilityCheckerService implements NucleusCapabilityContract {
  private readonly config = inject(ApplicationConfigService);

  hasCapability(capability: string): boolean {
    const authorities = this.config.getAuthorities() ?? [];
    return authorities.includes(capability);
  }
}
